import { PERMISSIONS } from '../consts/permissions';

export const mockPermissions: string[] = [
  PERMISSIONS.POSITION_VIEW,
  PERMISSIONS.MATCH_VIEW,
  PERMISSIONS.MATCH_CANDIDATE_VIEW,
  PERMISSIONS.MATCH_FLOW_VIEW,
  PERMISSIONS.MATCH_FLOW_RUN,
  PERMISSIONS.MATCH_CANDIDATE_PROMOTE,
  PERMISSIONS.MATCH_CANDIDATE_REJECT,

  // PERMISSIONS.POSITION_EDIT,
  // PERMISSIONS.POSITION_HISTORY_LOG_VIEW,
  // PERMISSIONS.POSITION_CREATE,
  // PERMISSIONS.TASKS_VIEW,
  // PERMISSIONS.MATCH_VIEW,
  // PERMISSIONS.MATCH_EDIT,
  // PERMISSIONS.MATCH_HISTORY_LOG_VIEW,
  // PERMISSIONS.MATCH_CREATE,
];
